"use client";

import { c as _c } from "react/compiler-runtime";
import type { SearchEntityResult } from "fansunited-data-layer";
import type { FUSportsEventDetails } from "../data/types";
import { cn } from "@/utilities/core/cn";
import { TeamLogo } from "@/components/ui/TeamLogo";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { extractPeriodScores, getAggregateScore } from "../utils/sportShape";
import type { SportEventSport } from "../utils/sportShape";
import { getEntityBrandColor, getEntityCountryCode, getEntityCountryFlag, getEntityLogo } from "../utils/entityHelpers";
interface Props {
  details: FUSportsEventDetails;
  entities: Record<string, SearchEntityResult>;
  sport: SportEventSport;
  periodLabelPrefix: string;
  periodHeaderLabel: string;
}
export function ScoreBreakdown(t0) {
  const $ = _c(74);
  const {
    details,
    entities,
    sport,
    periodLabelPrefix,
    periodHeaderLabel
  } = t0;
  const labels = useLabels();
  const t = labels.sportEventPage;
  const {
    event
  } = details.data;
  let logoKind;
  let one;
  let oneWon;
  let periods;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let total;
  let two;
  let twoWon;
  if ($[0] !== entities || $[1] !== event.competitorOne || $[2] !== event.competitorTwo || $[3] !== event.score || $[4] !== event.status || $[5] !== periodHeaderLabel || $[6] !== periodLabelPrefix || $[7] !== sport || $[8] !== t) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      periods = extractPeriodScores(event.score, sport, periodLabelPrefix);
      let t9;
      if ($[24] !== event.score) {
        t9 = getAggregateScore(event.score);
        $[24] = event.score;
        $[25] = t9;
      } else {
        t9 = $[25];
      }
      total = t9;
      if (periods.length === 0 && !total) {
        t8 = null;
        break bb0;
      }
      one = entities[event.competitorOne.id];
      two = entities[event.competitorTwo.id];
      logoKind = sport === "tennis" ? "player" : "team";
      const totalOneNum = total ? Number(total.one) : NaN;
      const totalTwoNum = total ? Number(total.two) : NaN;
      oneWon = event.status.type === "FINISHED" && !isNaN(totalOneNum) && !isNaN(totalTwoNum) && totalOneNum > totalTwoNum;
      twoWon = event.status.type === "FINISHED" && !isNaN(totalOneNum) && !isNaN(totalTwoNum) && totalTwoNum > totalOneNum;
      let t10;
      if ($[26] !== periodHeaderLabel || $[27] !== t.scoreBreakdown.overtimeNumbered || $[28] !== t.scoreBreakdown.penalties) {
        t10 = (kind, number) => {
          if (kind === "overtime") {
            return t.scoreBreakdown.overtimeNumbered.replace("{number}", String(number));
          }
          if (kind === "penalty") {
            return t.scoreBreakdown.penalties;
          }
          return `${periodHeaderLabel} ${number}`;
        };
        $[26] = periodHeaderLabel;
        $[27] = t.scoreBreakdown.overtimeNumbered;
        $[28] = t.scoreBreakdown.penalties;
        $[29] = t10;
      } else {
        t10 = $[29];
      }
      const periodTooltip = t10;
      t6 = "rounded-lg border border-border bg-card p-4 shadow-sm";
      if ($[30] !== t.scoreBreakdown.title) {
        t7 = <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-muted-foreground">{t.scoreBreakdown.title}</h2>;
        $[30] = t.scoreBreakdown.title;
        $[31] = t7;
      } else {
        t7 = $[31];
      }
      t5 = "overflow-x-auto";
      t4 = "min-w-full text-sm";
      t1 = "text-xs uppercase text-muted-foreground";
      if ($[32] !== periodHeaderLabel) {
        t2 = <th className="py-1 text-left">{periodHeaderLabel}</th>;
        $[32] = periodHeaderLabel;
        $[33] = t2;
      } else {
        t2 = $[33];
      }
      let t11;
      if ($[34] !== periodTooltip) {
        t11 = p => <th key={p.key} className="w-10 cursor-help py-1 text-center" title={periodTooltip(p.kind, p.number)}>{p.label}</th>;
        $[34] = periodTooltip;
        $[35] = t11;
      } else {
        t11 = $[35];
      }
      t3 = periods.map(t11);
    }
    $[0] = entities;
    $[1] = event.competitorOne;
    $[2] = event.competitorTwo;
    $[3] = event.score;
    $[4] = event.status;
    $[5] = periodHeaderLabel;
    $[6] = periodLabelPrefix;
    $[7] = sport;
    $[8] = t;
    $[9] = logoKind;
    $[10] = one;
    $[11] = oneWon;
    $[12] = periods;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = total;
    $[22] = two;
    $[23] = twoWon;
  } else {
    logoKind = $[9];
    one = $[10];
    oneWon = $[11];
    periods = $[12];
    t1 = $[13];
    t2 = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    total = $[21];
    two = $[22];
    twoWon = $[23];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[36] !== t.scoreBreakdown.total || $[37] !== t.scoreBreakdown.totalLong) {
    t9 = <th className="w-14 cursor-help py-1 text-center font-semibold text-foreground" title={t.scoreBreakdown.totalLong}>{t.scoreBreakdown.total}</th>;
    $[36] = t.scoreBreakdown.total;
    $[37] = t.scoreBreakdown.totalLong;
    $[38] = t9;
  } else {
    t9 = $[38];
  }
  let t10;
  if ($[39] !== t1 || $[40] !== t2 || $[41] !== t3 || $[42] !== t9) {
    t10 = <thead><tr className={t1}>{t2}{t3}{t9}</tr></thead>;
    $[39] = t1;
    $[40] = t2;
    $[41] = t3;
    $[42] = t9;
    $[43] = t10;
  } else {
    t10 = $[43];
  }
  const t11 = total?.one ?? "-";
  let t12;
  if ($[44] !== logoKind || $[45] !== one || $[46] !== oneWon || $[47] !== periods || $[48] !== t.competitorFallbackOne || $[49] !== t11 || $[50] !== twoWon) {
    t12 = <ScoreRow entity={one} fallbackName={t.competitorFallbackOne} logoKind={logoKind} periods={periods} totalValue={t11} side="one" isWinner={oneWon} isLoser={twoWon} />;
    $[44] = logoKind;
    $[45] = one;
    $[46] = oneWon;
    $[47] = periods;
    $[48] = t.competitorFallbackOne;
    $[49] = t11;
    $[50] = twoWon;
    $[51] = t12;
  } else {
    t12 = $[51];
  }
  const t13 = total?.two ?? "-";
  let t14;
  if ($[52] !== logoKind || $[53] !== oneWon || $[54] !== periods || $[55] !== t.competitorFallbackTwo || $[56] !== t13 || $[57] !== two || $[58] !== twoWon) {
    t14 = <ScoreRow entity={two} fallbackName={t.competitorFallbackTwo} logoKind={logoKind} periods={periods} totalValue={t13} side="two" isWinner={twoWon} isLoser={oneWon} />;
    $[52] = logoKind;
    $[53] = oneWon;
    $[54] = periods;
    $[55] = t.competitorFallbackTwo;
    $[56] = t13;
    $[57] = two;
    $[58] = twoWon;
    $[59] = t14;
  } else {
    t14 = $[59];
  }
  let t15;
  if ($[60] !== t12 || $[61] !== t14) {
    t15 = <tbody>{t12}{t14}</tbody>;
    $[60] = t12;
    $[61] = t14;
    $[62] = t15;
  } else {
    t15 = $[62];
  }
  let t16;
  if ($[63] !== t10 || $[64] !== t15 || $[65] !== t4) {
    t16 = <table className={t4}>{t10}{t15}</table>;
    $[63] = t10;
    $[64] = t15;
    $[65] = t4;
    $[66] = t16;
  } else {
    t16 = $[66];
  }
  let t17;
  if ($[67] !== t16 || $[68] !== t5) {
    t17 = <div className={t5}>{t16}</div>;
    $[67] = t16;
    $[68] = t5;
    $[69] = t17;
  } else {
    t17 = $[69];
  }
  let t18;
  if ($[70] !== t17 || $[71] !== t6 || $[72] !== t7) {
    t18 = <section className={t6}>{t7}{t17}</section>;
    $[70] = t17;
    $[71] = t6;
    $[72] = t7;
    $[73] = t18;
  } else {
    t18 = $[73];
  }
  return t18;
}
function ScoreRow(t0) {
  const $ = _c(39);
  const {
    entity,
    fallbackName,
    logoKind,
    periods,
    totalValue,
    side,
    isWinner,
    isLoser
  } = t0;
  const nameClass = isWinner ? "font-semibold text-foreground" : isLoser ? "text-muted-foreground" : "font-medium text-foreground";
  const totalClass = isWinner ? "font-bold text-foreground bg-foreground/5 rounded-sm" : isLoser ? "text-muted-foreground" : "font-semibold text-foreground";
  let t1;
  if ($[0] !== nameClass) {
    t1 = cn("inline-flex items-center gap-2", nameClass);
    $[0] = nameClass;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== entity) {
    t2 = getEntityLogo(entity);
    $[2] = entity;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== entity) {
    t3 = getEntityCountryCode(entity);
    $[4] = entity;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== entity) {
    t4 = getEntityCountryFlag(entity);
    $[6] = entity;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== entity) {
    t5 = getEntityBrandColor(entity, "primary");
    $[8] = entity;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== entity) {
    t6 = getEntityBrandColor(entity, "secondary");
    $[10] = entity;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== logoKind || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <TeamLogo src={t2} size="sm" kind={logoKind} countryCode={t3} countryFlag={t4} primaryColor={t5} secondaryColor={t6} />;
    $[12] = logoKind;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = entity?.name ?? fallbackName;
  let t9;
  if ($[19] !== t8) {
    t9 = <span>{t8}</span>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t1 || $[22] !== t7 || $[23] !== t9) {
    t10 = <td className="py-2 pr-4 text-left"><span className={t1}>{t7}{t9}</span></td>;
    $[21] = t1;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== periods || $[26] !== side) {
    let t12;
    if ($[28] !== side) {
      t12 = p => {
        const value = side === "one" ? p.one : p.two;
        const other = side === "one" ? p.two : p.one;
        const wins = value !== "" && other !== "" && !Number.isNaN(Number(value)) && !Number.isNaN(Number(other)) && Number(value) > Number(other);
        return <td key={p.key} className={cn("py-2 text-center tabular-nums", wins && "font-semibold text-foreground")}>{value || "-"}</td>;
      };
      $[28] = side;
      $[29] = t12;
    } else {
      t12 = $[29];
    }
    t11 = periods.map(t12);
    $[25] = periods;
    $[26] = side;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[30] !== totalClass) {
    t12 = cn("py-2 text-center tabular-nums", totalClass);
    $[30] = totalClass;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t12 || $[33] !== totalValue) {
    t13 = <td className={t12}>{totalValue}</td>;
    $[32] = t12;
    $[33] = totalValue;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t13) {
    t14 = <tr className="border-t border-border">{t10}{t11}{t13}</tr>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
}